// src/components/DescrizioneAttivita.js
// Descrizione di attività e sottoattività (ottobre 2026): più spazio (parte da ~6 righe e
// cresce mentre si scrive) e grassetto / corsivo con i pulsanti G e C o Ctrl+B / Ctrl+I.
// Quando non si scrive si legge già formattata. Si salva all'uscita dalla casella, come prima.
import React, { useEffect, useRef, useState } from "react";
import { TestoFormattato, applicaSegno } from "../utils/testoFormattato";

export default function DescrizioneAttivita({ valore, onSalva, disabilitato = false, placeholder = "Aggiungi una descrizione...", minRighe = 6 }) {
  const [modifica, setModifica] = useState(false);
  const [testo, setTesto] = useState(valore || "");
  const ref = useRef(null);

  // aggiornamenti arrivati da altri quando non si sta scrivendo (dopo il salvataggio si
  // continua a vedere il testo appena scritto, senza tornare un attimo a quello vecchio)
  const inModifica = useRef(false);
  inModifica.current = modifica;
  useEffect(() => { if (!inModifica.current) setTesto(valore || ""); }, [valore]);

  // la casella cresce con il testo
  useEffect(() => {
    const el = ref.current;
    if (!el || !modifica) return;
    el.style.height = "auto";
    el.style.height = Math.max(el.scrollHeight, minRighe * 21 + 16) + "px";
  }, [testo, modifica, minRighe]);

  useEffect(() => { if (modifica) ref.current?.focus(); }, [modifica]);

  const esci = () => {
    setModifica(false);
    if ((testo || "") !== (valore || "")) onSalva(testo);
  };
  const stile = (segno) => {
    const el = ref.current;
    if (!el) return;
    const r = applicaSegno(testo, el.selectionStart, el.selectionEnd, segno);
    setTesto(r.valore);
    requestAnimationFrame(() => { el.focus(); el.setSelectionRange(r.inizio, r.fine); });
  };
  const tasti = (e) => {
    if ((e.ctrlKey || e.metaKey) && (e.key === "b" || e.key === "B")) { e.preventDefault(); stile("**"); }
    if ((e.ctrlKey || e.metaKey) && (e.key === "i" || e.key === "I")) { e.preventDefault(); stile("_"); }
    if (e.key === "Escape") { e.preventDefault(); ref.current?.blur(); }
  };

  const btn = { width: 28, height: 26, border: "1px solid #e5e7eb", borderRadius: 6, background: "#fff", cursor: "pointer", fontSize: 13, color: "#374151", fontFamily: "Georgia, serif" };

  if (!modifica) {
    const vuoto = !(testo || "").trim();
    return (
      <div onClick={() => { if (!disabilitato) setModifica(true); }}
        title={disabilitato ? undefined : "Clicca per modificare"}
        style={{ minHeight: minRighe * 21 + 16, padding: "8px 10px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13.5, lineHeight: 1.55,
          color: vuoto ? "#9ca3af" : "#111827", cursor: disabilitato ? "default" : "text", background: disabilitato ? "#fafafa" : "#fff" }}>
        {vuoto ? (disabilitato ? "—" : placeholder) : <TestoFormattato testo={testo} />}
      </div>
    );
  }
  return (
    <div>
      <div style={{ display: "flex", gap: 4, marginBottom: 4, alignItems: "center" }}>
        <button type="button" onMouseDown={e => { e.preventDefault(); stile("**"); }} title="Grassetto (Ctrl+B)" style={{ ...btn, fontWeight: 800 }}>G</button>
        <button type="button" onMouseDown={e => { e.preventDefault(); stile("_"); }} title="Corsivo (Ctrl+I)" style={{ ...btn, fontStyle: "italic" }}>C</button>
        <span style={{ fontSize: 11, color: "#9ca3af", marginLeft: 6 }}>Seleziona il testo e premi G o C · si salva quando esci dalla casella</span>
      </div>
      <textarea ref={ref} className="input" value={testo} onChange={e => setTesto(e.target.value)} onBlur={esci} onKeyDown={tasti}
        placeholder={placeholder} style={{ width: "100%", resize: "vertical", fontSize: 13.5, lineHeight: 1.55, overflow: "hidden" }} />
    </div>
  );
}
